// create "window.Shoppad.apps.infiniteoptions" object if it doesn't already exist. From the documentation
"Shoppad.apps.infiniteoptions".split(".").reduce(function(o, x) { if (!o[x]) {o[x] ={};} return o[x] }, window);
// beforeReady callback
window.Shoppad.apps.infiniteoptions.beforeReady = function(subscribe) {
  subscribe('appLoad', function(event) {
    console.log('appLoad', event);
    
    const customElements = document.querySelectorAll('.option-swatch-custom');
    
    customElements.forEach(element => {
      const swatchElements = element.querySelectorAll('.spb-productoptionswatch');
      // extract class names, format "widthxheight"
      const sizeClasses = Array.from(element.classList).filter(className => className.includes('x'));
      // apply class size based on the index
      swatchElements.forEach((span, index) => {
        
        // if there is a size class for the current index
        if (sizeClasses[index]) {
          const [width, height] = sizeClasses[index].split('x').map(size => `${size}px`);
          span.style.width = width;
          span.style.height = height;
        }
      });
    });
  });
};